export function fromMillisecondsToSeconds(timeInMilliseconds) {
    return Math.floor(timeInMilliseconds / 1000);
}
export function sleep(delay) {
    return new Promise(resolve => {
        setTimeout(resolve, delay);
    });
}
//# sourceMappingURL=time.js.map